(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/init-scripts.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/init-scripts.js');
"use strict";


const {
  multiImageStyleElement,
  setLazyConfig
} = svs.content.image_v2.helpers;

setLazyConfig();

const multiImageElements = document.querySelectorAll('[data-multi-image-id]');
multiImageElements.forEach(imageElement => multiImageStyleElement.setupForImageElement(imageElement));

 })(window);